export const ANNOUNCEMENT_LEVELS = ['info', 'success', 'warning', 'critical'];
export const ANNOUNCEMENT_LIMITS = {
    maxMessageLength: 280,
    /** How many the bar shows at once; the newest win. */
    maxShown: 3,
};
